// 🎯 ترجمة أخطاء الـ API حسب لغة اليوزر، مكان واحد لكل السيستم.
// الشاشات بتعرض err.response.data.detail مباشرة، فلما الباك إند يرجّع detail
// كـ Object (زي ORG_HAS_DEPENDENTS) أو Array (أخطاء validation) كان بيظهر
// "[object Object]". والـ interceptor تحت بيحوّل detail لنص مترجم قبل ما يوصل
// لأي شاشة، والنسخة الأصلية بتفضل في data.detail_raw لو شاشة محتاجاها
import i18n from '../i18n';

const t = (key, defaultValue, options = {}) => i18n.t(key, { defaultValue, ...options });

const ORG_DEPENDENT_FALLBACKS = {
  sites: 'site(s)', assets: 'asset(s)', locations: 'location(s)', workorders: 'work order(s)',
  users: 'user(s)', vendors: 'vendor(s)', crafts: 'craft(s)', labor: 'labor record(s)',
  currency_rates: 'currency rate(s)', gl_accounts: 'GL account(s)', fiscal_years: 'fiscal year(s)', features: 'feature flag(s)'
};

const formatObjectDetail = (detail) => {
  if (detail.error_code === 'ORG_HAS_DEPENDENTS' && Array.isArray(detail.dependents)) {
    // الفاصلة العربية "،" للعربي والأوردو بدل ","
    const separator = ['ar', 'ur'].includes((i18n.language || '').slice(0, 2)) ? '، ' : ', ';
    const list = detail.dependents
      .map(d => `${d.count} ${t(`org_detail.deleteBlocked.types.${d.type}`, ORG_DEPENDENT_FALLBACKS[d.type] || d.type)}`)
      .join(separator);
    return t('org_detail.deleteBlocked.prefix',
      "Cannot delete organization '{{org}}': it still has {{list}} linked to it. Remove or reassign this data first.",
      { org: detail.org_id, list });
  }
  if (detail.error_code === 'ORG_DELETE_BLOCKED_GENERIC') {
    return t('org_detail.deleteBlocked.generic',
      "Cannot delete organization '{{org}}' because it still has other linked records in the system. Remove those first.",
      { org: detail.org_id });
  }
  if (detail.error_code) {
    return t(`apiErrors.${detail.error_code}`, detail.message || detail.error_code, detail.params || detail);
  }
  if (typeof detail.message === 'string') return detail.message;
  return JSON.stringify(detail);
};

// أخطاء FastAPI validation (422): [{loc: ['body', 'field'], msg: '...'}]
const formatValidationList = (items) => {
  const list = items.map(item => {
    if (!item || typeof item !== 'object') return String(item);
    const field = Array.isArray(item.loc) ? item.loc.filter(p => p !== 'body' && p !== 'query').join('.') : '';
    return field ? `${field}: ${item.msg}` : item.msg;
  }).join(' | ');
  return t('apiErrors.VALIDATION', 'Invalid data: {{list}}', { list });
};

/** نص الخطأ المترجم من رد الـ API (data = err.response.data) */
export const formatApiError = (data, fallback = '') => {
  if (!data || typeof data !== 'object') return fallback;
  // أخطاء الداتابيز: detail نص إنجليزي + error_code/params للترجمة
  if (data.error_code && typeof data.detail === 'string') {
    return t(`apiErrors.${data.error_code}`, data.detail, data.params || {});
  }
  const { detail } = data;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) return formatValidationList(detail);
  if (detail && typeof detail === 'object') return formatObjectDetail(detail);
  return fallback;
};

const translateErrorResponse = (error) => {
  const data = error?.response?.data;
  // الـ Blob (تصدير الإكسيل/الـ PDF) بيتقري في مكانه
  if (data && typeof data === 'object' && !(typeof Blob !== 'undefined' && data instanceof Blob)
      && (data.error_code || (data.detail && typeof data.detail !== 'string'))) {
    data.detail_raw = data.detail;
    data.detail = formatApiError(data, typeof data.detail === 'string' ? data.detail : '');
  }
  return Promise.reject(error);
};

export const installApiErrorTranslator = (instance) => {
  instance.interceptors.response.use((response) => response, translateErrorResponse);
};
